import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useCustomToast } from '../../components';
import {
  InventoryFilter,
  InventoryResponse,
} from '../../modules/Inventory/types';
import { InventoryReqAPI } from '../../modules/Inventory/api';

// Query key for caching
const keyQuery = ['inventory'] as const;

export const useFetchInventory = (filters?: Partial<InventoryFilter>) => {
  return useQuery<InventoryResponse, Error>({
    queryKey: [keyQuery, filters || {}],
    queryFn: ({ queryKey }) => InventoryReqAPI.gets({ queryKey }),
    enabled: true,
  });
};

export const useFetchInventoryById = (id?: string) => {
  return useQuery({
    queryKey: [...keyQuery, id],
    queryFn: () => (id ? InventoryReqAPI.get(id) : Promise.resolve(undefined)),
    enabled: !!id,
  });
};

// Create a new inventory request
export const useCreateInventory = () => {
  const { showToast } = useCustomToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: InventoryReqAPI.post,
    onSuccess: () => {
      showToast('success', 'Inventario creado');
      queryClient.invalidateQueries({ queryKey: [keyQuery, {}] });
    },
  });
};

// Delete a inventory request
export const useDeleteInventory = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => InventoryReqAPI.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keyQuery });
    },
  });
};

//Export excel
export const useExportInventory = () => {
  const { showToast } = useCustomToast();
  return useMutation({
    mutationFn: (ids: string[]) => InventoryReqAPI.export(ids),
    onSuccess: () => {
      showToast('success', 'Exportación exitosa');
    },
    onError: () => {
      showToast('error', 'Error al exportar');
    },
  });
};
